exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-box-wrapper {\n  display: flex;\n  height: auto;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 4px;\n  padding: 10px 5px;\n  height: 40px;\n  transition: all 0.3s; }\n  .text-box-wrapper.text-box-wrapper--invalid {\n    border: 1px solid firebrick;\n    box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.3); }\n  .text-box-wrapper .text-box-icon {\n    flex: 0 0 30px;\n    text-align: center; }\n  .text-box-wrapper input {\n    flex: 1;\n    margin: 0 10px 0 5px;\n    border: none;\n    font-size: 14px; }\n    .text-box-wrapper input:active, .text-box-wrapper input:focus {\n      border: none; }\n  .text-box-wrapper button {\n    padding: 5px 10px;\n    margin: 0; }\n    .text-box-wrapper button[disabled] {\n      opacity: 0.4;\n      cursor: not-allowed; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/components/text-box/text-box.scss
// module id = 362
// module chunks = 0